import DownloadLimitWidget from '@/components/app/utils/donwload-limit-widget/DownloadLimitWidget';
import Fall23Widget from '@/components/campaigns/fall23/Widget';
import DashboardIcons from '@/components/icons/dashboard';
import ElementsIcon from '@/components/icons/elements';
import FavoritesIcon from '@/components/icons/favourites';
import GslidesIcon from '@/components/icons/gslides';
import PptIcon from '@/components/icons/powerpoint';
import TemplateIcon from '@/components/icons/template';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Divider, Skeleton, Stack } from '@mui/material';
import { Button, Menu, Popover, Tag, Typography } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import StorageLimitWidget from '../utils/StorageLimit';
import UpgradeWidget from '../utils/UpgradeWidget';
import ElementsSideMenu from './elements-sidemenu/ElementsSideMenu';
import classes from './sidebar.module.css';
const { CheckableTag } = Tag;
const { Text } = Typography;

export default function Sidebar({ type }) {
   const router = useRouter();

   const nav = [
      {
         text: 'Dashboard',
         href: '/dashboard',
         icon: <DashboardIcons />,
      },
      {
         text: 'Templates',
         href: '/templates',
         icon: <TemplateIcon />,
      },
      {
         text: 'Elements',
         href: '/elements',
         icon: <ElementsIcon />,
      },
      {
         text: 'Favourites',
         href: '/favourites',
         icon: <FavoritesIcon />,
      },
   ];

   const tools = [
      {
         text: 'Brands',
         href: '/brands',
         icon: <i className="fi fi-rr-book-bookmark" />,
      },
      {
         text: 'Library',
         href: '/library',
         external: true,
         icon: <i className="fi fi-rr-folder" />,
      },
   ];

   const [software, setSoftware] = useState('');
   const { data, error, isLoading } = useSWR(process.env.NEXT_PUBLIC_PREMAST_API_URL + `/categories?parent_id=884`);
   const templateCategories = data?.categories;

   useEffect(() => {
      if (router.query.software) {
         setSoftware(router.query.software);
      } else {
         setSoftware('');
      }
   }, [router.query.software]);

   const handleSoftwareChange = (id) => {
      if (!id) {
         // remove software param from url
         const { software, ...rest } = router.query;
         router.push({
            pathname: router.pathname,
            query: rest,
         });
         return;
      }
      setSoftware(id);
      router.push({
         pathname: router.pathname,
         query: {
            ...router.query,
            software: id,
         },
      });
   };

   return (
      <>
         <Stack direction="column" className={classes.sidebar} justifyContent="space-between">
            {type === 'elements' && <ElementsSideMenu />}

            {type === 'templates' && (
               <Stack direction="column" spacing={4} className={classes.user}>
                  {isLoading && [...Array(10)].map((item, i) => <Skeleton key={i} variant="text" height={24} />)}
                  {templateCategories && (
                     <>
                        <Menu
                           selectedKeys={router.query.catId || 'all'}
                           style={{ background: 'transparent', border: 'none' }}
                           items={[
                              {
                                 key: 'all',
                                 label: <Link href={`/templates`}>All templates</Link>,
                              },
                           ].concat(
                              templateCategories?.map((item) => ({
                                 key: item.slug,
                                 label: <Link href={`/templates/${item.slug}`}>{item.name}</Link>,
                              }))
                           )}
                        />
                     </>
                  )}

                  {/* ANCHOR - select software */}
                  <Divider
                     textAlign="left"
                     flexItem
                     variant="middle"
                     sx={{
                        fontSize: '0.8rem',
                        lineHeight: '0px',
                        color: 'rgba(0, 0, 0, 0.5)',
                        padding: '1.5rem 0',
                     }}
                  >
                     Software
                  </Divider>
                  <Stack direction="column" spacing={8} className={classes.user}>
                     {software && (
                        <Button
                           type="text"
                           size="small"
                           onClick={() => handleSoftwareChange('')}
                           style={{ width: 'fit-content' }}
                           icon={<CloseCircleOutlined />}
                        >
                           Clear
                        </Button>
                     )}
                     <CheckableTag
                        checked={software && software === 'powerpoint'}
                        onChange={() => handleSoftwareChange('powerpoint')}
                        key={'884'}
                        style={{
                           fontSize: '14px',
                           display: 'flex',
                           alignItems: 'center',
                           gap: '2px',
                        }}
                     >
                        <PptIcon />
                        PowerPoint
                     </CheckableTag>

                     <CheckableTag
                        key={'6248'}
                        checked={software && software === 'google-slides'}
                        onChange={() => handleSoftwareChange('google-slides')}
                        style={{
                           fontSize: '14px',
                           display: 'flex',
                           alignItems: 'center',
                           gap: '2px',
                        }}
                     >
                        <GslidesIcon />
                        GoogleSlides
                     </CheckableTag>
                  </Stack>
               </Stack>
            )}

            {(!type || type === 'library') && (
               <Stack direction="column" spacing={10}>
                  <div style={{ padding: '0px 5px' }}>
                     <UpgradeWidget />
                  </div>
                  <Menu
                     items={nav.map((item) => ({
                        key: item.href,
                        label: <Link href={item.href}>{item.text}</Link>,
                        icon: item.icon,
                     }))}
                     selectedKeys={[router.pathname]}
                     mode="inline"
                     theme="light"
                     style={{ border: 'none', background: 'transparent', padding: 0 }}
                  />
                  <Divider
                     textAlign="left"
                     variant="middle"
                     sx={{
                        fontSize: '0.8rem',
                        lineHeight: '0px',
                        color: 'rgba(0, 0, 0, 0.5)',
                        margin: '1rem 0',
                     }}
                  >
                     Tools
                  </Divider>
                  <Menu
                     items={tools.map((item, i) => ({
                        key: item.href,
                        label: <Link href={item.href}>{item.text}</Link>,
                        icon: item.icon,
                        children: item.subMenu?.map((subItem) => ({
                           label: (
                              <Link href={subItem.href}>
                                 <Text type="secondary" style={{ fontSize: '0.8rem' }}>
                                    {subItem.text}
                                 </Text>
                              </Link>
                           ),
                        })),
                     }))}
                     selectedKeys={[router.pathname]}
                     mode="inline"
                     theme="light"
                     style={{ border: 'none', background: 'transparent', padding: 0 }}
                  />
               </Stack>
            )}
            <Stack direction="column" spacing={4} className={classes.widget} style={{ marginTop: 'auto' }}>
               {
                  // remove this after 29 may 2023
                  new Date() < new Date('2023-05-29') && (
                     <Popover
                        content={
                           <Stack direction="column" spacing={4} style={{ width: '300px' }}>
                              <Text>
                                 🎉 Exclusive on Product Hunt: 30% off Premast plans for 48 hours! Don't miss it.
                              </Text>
                           </Stack>
                        }
                        placement="leftTop"
                        trigger="hover"
                     >
                        <a
                           href="https://www.producthunt.com/posts/premast-2?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-premast&#0045;2"
                           target="_blank"
                           rel="noreferrer"
                           style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}
                        >
                           <Image
                              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=392559&theme=neutral"
                              width={250}
                              height={54}
                              alt="Premast - The ultimate presentation creation tool | Product Hunt"
                              style={{ width: '100%' }}
                           />
                        </a>
                     </Popover>
                  )
               }
            </Stack>
            <Stack
               direction="column"
               spacing={4}
               className={classes.widget}
               style={{ padding: '0 1rem', width: '100%' }}
            >
               <Fall23Widget />
               {type === 'templates' && <DownloadLimitWidget />}
               {type === 'library' && <StorageLimitWidget />}
            </Stack>
         </Stack>
      </>
   );
}
